import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, type LazyComponent, LazyModule } from "owa-bundling";
import type { LightningProps } from "./types/LightningProps";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "Lightning"*/ "./lazyIndex"), {
    name: "Lightning",
});

export const Lightable: LazyComponent<LightningProps & {
    children?: React.ReactNode;
}, unknown, void> = createLazyComponent(lazyModule, m => m.Lightable);
